


























import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from './store/store';
import * as signalR from '@aspnet/signalr';
import config from './config/index';
import Navmenu from '@/components/NavMenu.vue';
import Header from '@/components/Header.vue';
Vue.component('menu-component', Navmenu);
Vue.component('header-component', Header);

interface AppData {
  timer: any // 定时器
}

declare var $: any;

export default Vue.extend({
  name: 'App',
  data(): AppData {
    return {
      timer: null
      // footer: ''
    };
  },
  computed: mapState({
    tableHeader: (state: any) => store.getters.getTableHeader,
    menuIndex: (state: any) => store.getters.getMenuIndex,
    loading: (state: any) => store.getters.getLoading,
    userInfo: (state: any) => store.getters.getUserInfo,
    menuIsCollapse: (state: any) => store.getters.getMenuIsCollapse
  }),
  methods: {
    // 鼠标滚动事件
    handleScroll() {
      // 函数节流
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const scrollTop = (document as any).querySelector('#viewBox').scrollTop;
        // 判断滚动条高度，是否显示固定表头
        if (scrollTop > this.tableHeader.scrollTop) {
          this.$store.dispatch('setTableHeader', {
            isShow: true,
            scrollLeft: $(window).scrollLeft()
          });
        } else {
          this.$store.dispatch('setTableHeader', {
            isShow: false
          });
        }
      }, 0);
    },
    // 初始化signalr
    initSignalR() {
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.BASE_URL}sk/checkHub`, {
          transport: signalR.HttpTransportType.LongPolling
        }).build();

      connection.on('Send', (msg: any) => {
        console.log(JSON.parse(msg));
        this.$store.dispatch('updateCheckResult', JSON.parse(msg));
      });

      connection.start().catch();
    },
    interceptor() {
      // 请求拦截器
      this.$http.interceptors.request.use(
        (config: any) => {
          if (config.method === 'get') {
            config.params = {
              _t: new Date().getTime(),
              ...config.params
            };
          }
          return config;
        }
      );
      // 响应拦截器
      this.$http.interceptors.response.use(
        (response: any) => {
          return response;
        },
        (error: any) => {
          if (error.response) {
            switch (error.response.status) {
              case 401:
                window.location.href = error.response.headers.location;
                break;
            }
          }
        }
      );
    }
  },
  created() {
    this.interceptor();
    this.$store.dispatch('setCheckHomeUrl');
    this.$store.dispatch('setUserInfo');
    // this.$store.dispatch('setPermission');
  },
  mounted() {
    this.initSignalR();
    window.addEventListener('scroll', this.handleScroll);
  }
});
